import { render, staticRenderFns } from "./modal-del-subuser-group.vue?vue&type=template&id=4882c2f3&"
import script from "./modal-del-subuser-group.vue?vue&type=script&lang=js&"
export * from "./modal-del-subuser-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports